/*
 * @Author: your name
 * @Date: 2021-07-12 11:51:23
 * @LastEditTime: 2022-02-16 10:02:08
 * @LastEditors: Please set LastEditors
 * @Description: mapApi
 * @FilePath: \contingency-manage\src\views\map\js\MapApi.js
 */

import CerateMap from "./modular/CreateMap";
import handleCoordinates from "./modular/handleCoordinates";
import MyDeaw from "./modular/Draw";
import Location from "./modular/location";
import Marker from "./modular/Marker";
import Heatmap from "./modular/Heatmap";
import LineMarker from "./modular/LineMarker";
import MoveLine from "./modular/MoveLine";
import Measure from "./modular/Measure";
import Overlay from "ol/Overlay";
import { getDistance } from 'ol/sphere';
import { useContext, createContext } from "@/hooks/core/useContext.js";
export let myMap
export default function mapApi() {
  // 地图加载完成
  const loadEvents = new Set();
  const clickMapEvents = new Set();
  const data = {
    mapView: "",
    map: "",
    polygonSource: "",
    draw: "",
    drawVector: "",
    mapLoad: false,
    cameraPointRef: [],
    baidu: null,
    zoom: window.mapView.zoom,
    lineMarkerArr: []
  };

  let myMapLayers, myMapView;

  const { setPoint, reversePoint } = handleCoordinates();
  const createMap = new CerateMap();

  // 初始化地图
  const initOlMap = (target) => {
    const { map, mapLayers, mapView } = createMap.init(target);
    myMapLayers = mapLayers;
    myMapView = mapView;
    myMap = map;
    myMap.on("moveend", function(e) {
      const zoom = myMapView.getZoom(); // 获取当前地图的缩放级别
      self.zoom = zoom;
      data.zoom = zoom;
    });
    myMap.on("singleclick", function(e) {
      // 调用摄像机组件的事件
      clickMapEvents.forEach(fn => {
        fn(e, reversePoint(e.coordinate), data.zoom);
      });
    });
    createContext("myMapContext", { myMap, myMapLayers, myMapView });

    data.mapLoad = true;
    setTimeout(function() {
      loadEvents.forEach(fn => {
        fn(myMap);
      });
      loadEvents.clear();
    }, 100);
  };
  /* --------- 事件  ------------ */
  /**
   * 地图加载完成时触发
   * @param {*} fn 回调函数
   * @return {*} myMap 地图实例
   */
  const loadMap = fn => {
    if (fn) {
      loadEvents.add(fn);
    }
  };
  /**
   * 点击地图时触发
   * @param {*} fn 回调函数
   */
  const clickMap = fn => {
    if (fn) {
      clickMapEvents.add(fn);
    }
  };
  //取消地图取点
  const cancelClickMap = () => {
    clickMapEvents.clear();

  };
  /* --------- 绘制  ------------ */
  const myDeaw = new MyDeaw();
  // 绘制多边形或圆
  const addInteractions = (type, callback, addDel, ) => {
    myDeaw.addInteractionsApi(myMap, type, corrdinates => {
      // corrdinates.forEach(points => {
      //   points.forEach(point => {
      //     point = reversePoint(point);
      //   });
      // });
      callback && callback(corrdinates);
    }, addDel);
  };

  // 清除绘制多变型内容
  const remDraw = (num, callback) => {
    myDeaw.remDrawApi(myMap, num, geometryArr => {
      callback && callback(geometryArr);
    }, num);
  };
  // 清除绘制所有
  const remAllDraw = () => {
    myDeaw.remAllDrawApi(myMap);
  };
  // 加载多边形
  const renderArea = (list, areaColor) => {
    myDeaw.renderAreaApi(myMap, list, areaColor);
  };
  // 清除加载的多边形
  const remArea = async() => {
    return await myDeaw.remAreaApi(myMap);
  };
  /* --------- 定位  ------------ */
  const location = new Location();
  // 地图定位
  const mapLocation = (loc, defineZoom) => {
    location.fly(myMapView, loc, defineZoom);
  };
  /* --------- 路径  ------------ */
  const lineMarker = new LineMarker();
  const moveLine = new MoveLine();
  // 地图路径初始化
  const mapLineInit = () => {
    lineMarker.initLine();
  };
  // 地图添加路径
  const mapLine = data => {
    lineMarker.addline(myMap, data);
  };
  const mapLineArrow = data => {
    //带箭头路径
    lineMarker.addLineArrow(myMap, data);
  };
  const mapMoveAddLine = data => {
    //边走边添加路径
    moveLine.addlineByMove(myMap, data);
  };
  const mapStartMoveAddLine = data => {
    //边走边添加路径动画停止
    moveLine.startAnimation();
  };
  const mapStopMoveAddLine = data => {
    //边走边添加路径动画停止
    moveLine.stopAnimation();
  };
  const clearMoveAddLine = () => {
    //清除边添加路径
    moveLine.clearLine(myMap);
  };
  const mapLineArrowArr = (dataArr) => {
    dataArr.forEach((item) => {
        const lineMarker = new LineMarker();
        lineMarker.addLineArrow(myMap, item);
        data.lineMarkerArr.push(lineMarker)
      })
      // setTimeout(() => {
      //   mapLineArrowArrDel()
      // }, 5000);
  };
  const mapLineArrowArrDel = () => {
    data.lineMarkerArr.forEach((item) => {
      item.clearLine(myMap);
    })
  };
  // 清除路径
  const clearLine = () => {
    lineMarker.clearLine(myMap);
  };
  //开始动画
  const startMapLine = () => {
      lineMarker.startAnimation();
    }
    //结束动画
  const stopMapLine = () => {
      lineMarker.stopAnimation();
    }
    //改变运动速度
  const changeMoveSpeed = (speed) => {
      lineMarker.speed = speed;
    }
    //获取距离
  const getMapLineDistance = () => {
    return lineMarker
  }

  /* --------- 点位操作  ------------ */
  const marker = new Marker();
  // 添加点位
  const addMarker = data => {
    marker.addMarker(myMap, data);
  };
  // 删除点位
  const remMarker = data => {
    marker.remMarker(data);
  };
  // 删除点位
  const clearMarker = async() => {
    return await marker.clearMarker(myMap);
  };

  /* --------- 测量  ------------ */
  const measure = new Measure();
  // 距离测距
  const distanceMeasure = () => {
    measure.distance(myMap);
  };
  // 根据两点测距距离
  const getDistanceApi = (poi1, poi2) => {
    return getDistance(poi1, poi2);
  };
  // 清空测量记录
  const clearMeasure = () => {
    measure.clearMeasureRecord(myMap);
  };

  // 绘制自定义componment
  const drawComponment = (el, piont, option) => {
    const marker = new Overlay({
      element: el,
      ...option
    });
    marker.setPosition(setPoint(piont));
    myMap.addOverlay(marker);

  };
  // 绘制自定义componment
  const getOverlay = () => {
    console.log(myMap);
  };
  // 绘制自定义componment
  const drawImages = (el, props, state) => {
    const data = {
      poiType: state.poiType
    };
    state.popup = new Overlay({
      element: el.value,
      data: Object.assign(data, props.infoData)
    });
    state.popup.setPosition(setPoint(props.infoData.location));
    myMap && myMap.addOverlay(state.popup);
  };
  /* --------- 添加热力图  ------------ */
  const heatmap = new Heatmap();
  // 添加点位
  const addHeatmap = data => {
    heatmap.addHeatMap(myMap, data);
  };
  // 添加点位
  const clearHeatmap = () => {
    heatmap.clearHeatMap(myMap);
  };
  // 重置地图
  const resetMap = () => {
    loadEvents.clear();
    clickMapEvents.clear();
    clearMarker();
    remArea();
  };
  return {
    data,
    myMap,
    resetMap,
    setPoint,
    initOlMap,
    renderArea,
    addInteractions,
    remDraw,
    remAllDraw,
    remArea,
    mapLocation,
    addMarker,
    remMarker,
    clearMarker,
    distanceMeasure,
    clearMeasure,
    loadMap,
    clickMap,
    cancelClickMap,
    drawComponment,
    drawImages,
    getOverlay,
    mapLineInit,
    mapLine,
    mapLineArrow,
    mapLineArrowArr,
    mapLineArrowArrDel,
    mapMoveAddLine,
    mapStartMoveAddLine,
    mapStopMoveAddLine,
    clearMoveAddLine,
    clearLine,
    startMapLine,
    stopMapLine,
    changeMoveSpeed,
    getMapLineDistance,
    getDistanceApi,
    addHeatmap,
    clearHeatmap
  };
}